export const START_LOGIN = "auth/START_LOGIN";
export const LOGIN_SUCCESS = "auth/LOGIN_SUCCESS";
export const LOGIN_FAILURE = "auth/LOGIN_FAILURE";
export const RESET_ERROR = "auth/RESET_ERROR";
export const LOGIN_USER = "auth/LOGIN_USER";
export const SIGN_OUT_SUCCESS = "auth/SIGN_OUT_SUCCESS";
